import React from 'react';
import { SocialLinks } from './SocialLinks';

export const InstagramSection = () => (
  <section className="py-12 bg-gray-100" data-testid="social-section">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <p className="text-gray-600 mb-3 font-medium">Follow us:</p>
      <SocialLinks size="lg" idPrefix="social-section" />
    </div>
  </section>
);
